export default {
  courseFaqs: [],
  processing: false,
  error: null,
  success: null,
}



